import './TrackmanEvents.scss';

import Separator from 'components/Separator/Separator';
import { useTranslation } from 'react-i18next';
import { OnDemandRecordings } from './OnDemandRecordings/OnDemandRecordings';
import { UpcomingEventsNew } from './UpcomingEvents/UpcomingEvents';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { useGetTrackmanEventsList } from 'queryHooks/trackmanEvents';

export const TrackmanEvents = () => {
  const { t } = useTranslation();
  useSetPageTitle({
    title: t('Events', { ns: 'trackmanEvents' }),
  });

  const trackmanEventsList = useGetTrackmanEventsList();

  return (
    <>
      <div className='default-page-header'>
        <h1 className='page-title'>{t('Events', { ns: 'trackmanEvents' })}</h1>
        <span className='page-subtitle'>{t('StayUpdatedAboutUpcomingEvents', { ns: 'trackmanEvents' })}</span>
      </div>
      <div className='trackman-events-wrapper'>
        <UpcomingEventsNew />
        {trackmanEventsList.data?.length ? <Separator /> : null}
        <OnDemandRecordings />
      </div>
    </>
  );
};
